import TrustedIcon from "../../core/ui/icon/Trusted.svg";
import VerifiedIcon from "../../core/ui/icon/Verified.svg";
import SuspiciousIcon from "../../core/ui/icon/Suspicious.svg";

import {PeraLabeledAsset} from "../util/assetModels";

function generateAssetVerificationBadgeAttributes(
  verificationTier: PeraLabeledAsset["verification_tier"]
) {
  let description = "";
  let iconSrc = "";
  let altText = "";

  switch (verificationTier) {
    case "trusted":
      description = "Trusted asset by Pera";
      iconSrc = TrustedIcon;
      altText = "Trusted asset badge";
      break;

    case "verified":
      description = "Verified asset by Pera";
      iconSrc = VerifiedIcon;
      altText = "Verified asset badge";
      break;

    case "suspicious":
      description = 'Marked as "Suspicious" by Pera';
      iconSrc = SuspiciousIcon;
      altText = "Suspicious asset badge";
      break;

    default:
      break;
  }

  return {
    description,
    iconSrc,
    altText
  };
}

export {generateAssetVerificationBadgeAttributes};
